import React, { useEffect, useState } from "react";
import http from "../../../services/http";
import {
  getAPIURL,
  getFormattedPrice,
  getVendorSettings,
} from "../../../services/helper";
import Barcode from "react-barcode";
import Loader from "../../../Layout/Loader";

const OrderInvoice = ({ order_id }) => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const vendor_email = getVendorSettings("email");
  const vendor_store_name = getVendorSettings("name");
  const vendor_address = getVendorSettings("vendor_contact_address");
  const vendor_phone = getVendorSettings("vendor_contact_phone");

  const {
    showStoreName,
    showStorePhone,
    showStoreAddress,
    showStoreEmail,
    showStoreLogo,
    headerNote,
    footerNote,
  } = getVendorSettings("receiptTemplate") || {};

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const api_url = getAPIURL();
        const { data: orderRes } = await http.get(
          `${api_url}/order/${order_id}`
        );
        setOrder(orderRes.data);
        setTimeout(() => window.print(), 500); // Trigger print
      } catch (err) {
        console.error("Error loading order:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [order_id]);

  if (loading || !order) return <Loader />;

  const subtotal = order.items.reduce(
    (acc, item) => acc + parseFloat(item.price) * parseInt(item.quantity),
    0
  );

  console.log(order);

  const date = new Date(order.date);
  const formattedDate = date.toLocaleDateString();
  const formattedTime = date.toLocaleTimeString();

  const changeDue = order.paid - order.grandTotal;

  return (
    <div
      style={{
        fontFamily: "monospace",
        padding: "10px",
        maxWidth: "350px",
        margin: "0 auto",
        backgroundColor: "#fff",
        fontSize: "12px",
      }}
    >
      {/* Top Barcode */}
      <div className="text-center mb-2">
        <Barcode displayValue={false} height={40} value={`order-${order.id}`} />
      </div>

      {/* Store Info */}
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        {showStoreName && (
          <div style={{ fontWeight: "bold", fontSize: "16px" }}>
            {vendor_store_name}
          </div>
        )}
        {showStoreAddress && <div>{vendor_address}</div>}
        {showStorePhone && <div>Tel: {vendor_phone}</div>}
        {showStoreEmail && <div>{vendor_email}</div>}
        {headerNote && <div className="mt-1">{headerNote}</div>}
      </div>

      {/* Order Info */}
      <div style={{ marginBottom: "10px" }}>
        <div>
          Date: {formattedDate} {formattedTime}
        </div>
        <div>Order #: {order.id}</div>
        <div>Status: {order.order_status}</div>
        <div>Type: {order.order_type}</div>
      </div>

      {/* Items */}
      <div
        style={{
          borderTop: "1px dashed #000",
          marginTop: "10px",
          paddingTop: "10px",
        }}
      >
        {order.items.map((item, index) => (
          <div key={index} style={{ marginBottom: "6px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                {item.quantity}x {item.name}
              </div>
              <div>{getFormattedPrice(item.quantity * item.price)}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Totals */}
      <div
        style={{
          borderTop: "1px dashed #000",
          marginTop: "10px",
          paddingTop: "10px",
        }}
      >
        <div className="d-flex justify-content-between">
          <span>Subtotal:</span>
          <span>{getFormattedPrice(subtotal)}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>Discount:</span>
          <span>{getFormattedPrice(order.discount_total)}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>Total:</span>
          <span>{getFormattedPrice(order.grandTotal)}</span>
        </div>
        {order.split_payment?.payments ? (
          <>
            {order.split_payment.payments.map((payment, idx) => (
              <div key={idx} className="d-flex justify-content-between">
                <span>{payment.type}:</span>
                <span>{getFormattedPrice(payment.amount)}</span>
              </div>
            ))}
            <div className="d-flex justify-content-between">
              <span>Total Paid:</span>
              <span>{getFormattedPrice(order.split_payment.totalPaid)}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Change Due:</span>
              <span>{getFormattedPrice(Math.max(0, order.split_payment.totalPaid - order.grandTotal))}</span>
            </div>
          </>
        ) : (
          <>
            <div className="d-flex justify-content-between">
              <span>Tendered:</span>
              <span>{getFormattedPrice(order.grandTotal)}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Change Due:</span>
              <span>{getFormattedPrice(changeDue)}</span>
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      {footerNote && (
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          {footerNote}
        </div>
      )}

      {/* Bottom Barcode */}
      <div className="text-center mt-2">
        <Barcode displayValue={false} height={40} value={`order-${order.id}`} />
      </div>
    </div>
  );
};

export default OrderInvoice;
